import React from 'react'
import injectSheet from 'react-jss'
import update from 'immutability-helper'
import { Container, Draggable } from 'react-smooth-dnd'
import { Add } from '../../icons/actionIcons'
import {
  AdminNodeListItem,
  IconButton,
} from '../../'

class AdminNodeListItemRec extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      open: (props.node && props.node.nodeType === 'Root'),
    }

    this.getChildPayload = this.getChildPayload.bind(this)
    this.handleOpen = this.handleOpen.bind(this)
    this.updateOrder = this.updateOrder.bind(this)
  }

  getChildPayload(index) {
    return this.props.node.children[index]
  }

  handleOpen() {
    const {
      node,
      setActive,
    } = this.props

    this.setState({
      open: !this.state.open,
    })
    setActive(node.id)
  }

  updateOrder(args) {
    const {
      removedIndex,
      addedIndex,
      payload,
    } = args

    const {
      config,
      node,
    } = this.props

    const updatedNode = update(node, {
      children: {
        $splice: [
          [removedIndex, 1],
          [addedIndex, 0, payload],
        ],
      },
    })
    return this.props[`update${node.nodeType}Mutation`]({
      variables: config.drag[node.nodeType].variables(node.id, updatedNode.children),
    })
  }

  render() {
    const {
      active,
      classes,
      config,
      level,
      node,
      nodes,
      setActive,
    } = this.props

    const { open } = this.state

    return (
      <li className={`${classes.item} ${open && 'open'} ${((active && node) && (active.id === node.id)) && 'active'} ${node && (node.nodeType === 'Root') && 'root'}`}>
        <div className={`${classes.content}`}>
          <div
            className={`${classes.titleButton}`}
            role="button"
            tabIndex={0}
            onClick={this.handleOpen}
            onKeyDown={() => false}
          >
            {node && node.title}
          </div>
          <div className={`${classes.actions}`}>
            {(config.create[level] && ('mutation' in config.create[level])) && (
              <IconButton
                handleClick={async () => {
                  const newId = await this.props[config.create[level].mutation]({
                    variables: config.create[level].variables(node.id),
                  }).then(res => res.data[config.create[level].res].id)
                  this.setState({
                    open: true,
                  })
                  setActive(newId)
                }}
                index={0}
                icon={<Add />}
                tip={config.create[level].action}
              />
            )}
          </div>
        </div>
        {node && node.children && Array.isArray(node.children) && (node.children.length > 0) && (
          <ul>
            <Container
              onDrop={this.updateOrder}
              getChildPayload={this.getChildPayload}
            >
              {node.children.map(child => (
                <Draggable key={`nodeList-${child}`}>
                  <AdminNodeListItem
                    config={config}
                    id={child}
                    level={level + 1}
                    nodes={nodes}
                    parent={node}
                  />
                </Draggable>
              ))}
            </Container>
          </ul>
        )}
      </li>
    )
  }
}

const styles = theme => ({
  item: {
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    '&.root > $content $titleButton': {
      fontSize: '120%',
      color: theme.colors.secondary_3b,
      fontWeight: 'bold',
    },
    '& ul': {
      display: 'none',
      width: '100%',
    },
    '&.open > ul': {
      display: 'initial',
    },
    '&.active > $content': {
      borderColor: theme.colors.main_1,
    },
  },
  content: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    margin: '2px 0',
    backgroundColor: theme.colors.main_2,
    borderWidth: '1px',
    borderColor: theme.colors.main_2,
    borderRadius: '3px',
    borderStyle: 'solid',
    color: theme.colors.main_3,
    transition: [
      {
        property: 'color',
        duration: theme.speed.fast,
      },
      {
        property: 'border-color',
        duration: theme.speed.fast,
      },
    ],
    '&:hover': {
      color: theme.colors.secondary_3b,
      borderColor: theme.colors.main_3,
    },
  },
  titleButton: {
    padding: `${theme.sizes.gutter / 2}px`,
    cursor: 'pointer',
    width: '100%',
  },
  actions: {
    padding: `${theme.sizes.gutter / 2}px`,
    display: 'flex',
    '& > div': {
      margin: '0 2px',
    },
  },
})


export default injectSheet(styles)(AdminNodeListItemRec)



// WEBPACK FOOTER //
// ./src/modules/admin/components/adminNodeListItem.jsx